(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@babel/runtime/helpers/taggedTemplateLiteral'), require('@babel/runtime/regenerator'), require('@babel/runtime/helpers/toConsumableArray'), require('@babel/runtime/helpers/objectSpread'), require('@babel/runtime/helpers/asyncToGenerator'), require('cross-fetch'), require('@babel/runtime/helpers/defineProperty'), require('@babel/runtime/helpers/objectWithoutProperties')) :
  typeof define === 'function' && define.amd ? define(['exports', '@babel/runtime/helpers/taggedTemplateLiteral', '@babel/runtime/regenerator', '@babel/runtime/helpers/toConsumableArray', '@babel/runtime/helpers/objectSpread', '@babel/runtime/helpers/asyncToGenerator', 'cross-fetch', '@babel/runtime/helpers/defineProperty', '@babel/runtime/helpers/objectWithoutProperties'], factory) :
  (global = global || self, factory(global['covergo-sdk'] = {}, global._taggedTemplateLiteral, global._regeneratorRuntime, global._toConsumableArray, global._objectSpread, global._asyncToGenerator, global.crossFetch, global._defineProperty, global._objectWithoutProperties));
}(this, function (exports, _taggedTemplateLiteral, _regeneratorRuntime, _toConsumableArray, _objectSpread, _asyncToGenerator, crossFetch, _defineProperty, _objectWithoutProperties) { 'use strict';

  _taggedTemplateLiteral = _taggedTemplateLiteral && _taggedTemplateLiteral.hasOwnProperty('default') ? _taggedTemplateLiteral['default'] : _taggedTemplateLiteral;
  _regeneratorRuntime = _regeneratorRuntime && _regeneratorRuntime.hasOwnProperty('default') ? _regeneratorRuntime['default'] : _regeneratorRuntime;
  _toConsumableArray = _toConsumableArray && _toConsumableArray.hasOwnProperty('default') ? _toConsumableArray['default'] : _toConsumableArray;
  _objectSpread = _objectSpread && _objectSpread.hasOwnProperty('default') ? _objectSpread['default'] : _objectSpread;
  _asyncToGenerator = _asyncToGenerator && _asyncToGenerator.hasOwnProperty('default') ? _asyncToGenerator['default'] : _asyncToGenerator;
  _defineProperty = _defineProperty && _defineProperty.hasOwnProperty('default') ? _defineProperty['default'] : _defineProperty;
  _objectWithoutProperties = _objectWithoutProperties && _objectWithoutProperties.hasOwnProperty('default') ? _objectWithoutProperties['default'] : _objectWithoutProperties;

  var coverFetch =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _ref2,
          query,
          _ref2$variables,
          variables,
          _ref2$token,
          token,
          _ref2$locale,
          locale,
          _ref2$options,
          options,
          _ref2$__debug,
          __debug,
          _ref2$errorLocation,
          errorLocation,
          method,
          json,
          opts,
          res,
          resData,
          errors,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, query = _ref2.query, _ref2$variables = _ref2.variables, variables = _ref2$variables === void 0 ? {} : _ref2$variables, _ref2$token = _ref2.token, token = _ref2$token === void 0 ? '' : _ref2$token, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? "en" : _ref2$locale, _ref2$options = _ref2.options, options = _ref2$options === void 0 ? {
                url: "https://api.covergo.com/graphql"
              } : _ref2$options, _ref2$__debug = _ref2.__debug, __debug = _ref2$__debug === void 0 ? false : _ref2$__debug, _ref2$errorLocation = _ref2.errorLocation, errorLocation = _ref2$errorLocation === void 0 ? null : _ref2$errorLocation;
              _context.prev = 1;
              method = "POST";
              if (!query) console.error("There was no query to send");
              json = JSON.stringify({
                query: query,
                variables: variables
              });
              opts = {
                method: method,
                headers: _objectSpread({
                  "Content-Type": "application/json",
                  "Accept-Language": locale,
                  "Authorization": "Bearer ".concat(token)
                }, options.headers && options.headers),
                body: json
              };
              _context.next = 9;
              return crossFetch.fetch(options.url, opts);

            case 9:
              res = _context.sent;

              /* istanbul ignore next */
              if (__debug) {
                console.group("%cCalling CoverGo API", "background: #03aeef; color: white; font-weight: bold; padding: 2px 4px; font-family: monospace;");
                console.log({
                  query: query
                });
                console.log({
                  variables: variables
                });
                if (res.errors) console.log("%cThere is an error here!", "color: #CE0528; font-weight: bold;"); // Stringified query and variables

                console.groupCollapsed("> Stringified");
                console.log(query + "\n" + JSON.stringify(variables));
                console.groupEnd();
                console.groupEnd();
              }
              /* istanbul ignore next */


              if (!(res.status >= 400)) {
                _context.next = 13;
                break;
              }

              throw new Error('Network error from GQL');

            case 13:
              _context.next = 15;
              return res.json();

            case 15:
              resData = _context.sent;
              errors = [];

              if (errorLocation && typeof errorLocation === 'string') {
                // resolve errors by following the given dotobject path (only simple paths, no arrays or bracket notation)
                errors = _toConsumableArray(errorLocation.split(".").reduce(function (acc, cur) {
                  return acc[cur] || null;
                }, _objectSpread({}, resData)));
              } else if (errorLocation && typeof errorLocation === 'function') {
                // resolve errors through custom function
                errors = _toConsumableArray(errorLocation(resData));
              } else if (!errorLocation && resData.data) {
                // resolve errors from top level results type of data object
                errors = _toConsumableArray(Object.keys(resData.data).map(function (key) {
                  return resData.data[key].errors || [];
                }).reduce(function (acc, cur) {
                  return [].concat(_toConsumableArray(acc), _toConsumableArray(cur));
                }, []));
              }

              return _context.abrupt("return", Promise.resolve(_objectSpread({}, resData, errors.length && {
                errors: errors
              }, errors.length && {
                otherErrors: resData.errors // if we are replacing the errors array we move other errors to otherErrors property

              })));

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](1);
              return _context.abrupt("return", {
                errors: [{
                  message: _context.t0
                }]
              });

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 21]]);
    }));

    return function coverFetch() {
      return _ref.apply(this, arguments);
    };
  }();

  function gql(strings) {
    var _this = this;

    for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      values[_key - 1] = arguments[_key];
    }

    var query = '';
    strings.forEach(function (string, i) {
      query += string + (values[i] || '');
    });

    var returnFn = function returnFn(_ref3) {
      var variables = _ref3.variables,
          token = _ref3.token,
          locale = _ref3.locale,
          options = _ref3.options,
          __debug = _ref3.__debug;
      return coverFetch.call(_this, {
        query: query,
        variables: variables,
        token: token,
        locale: locale,
        options: options,
        __debug: __debug
      });
    };

    returnFn.withFieldErrorMapping = function (errorLocation) {
      return function (_ref4) {
        var variables = _ref4.variables,
            token = _ref4.token,
            locale = _ref4.locale,
            options = _ref4.options,
            __debug = _ref4.__debug;
        return coverFetch({
          query: query,
          variables: variables,
          token: token,
          locale: locale,
          options: options,
          __debug: __debug,
          errorLocation: errorLocation || true
        });
      };
    };

    return returnFn;
  }

  function _templateObject() {
    var data = _taggedTemplateLiteral(["\n  mutation addLink($linkInput: createLinkInput!){\n    addLink(linkInput: $linkInput) {\n      status\n      errors\n    }\n  }\n"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }
  var addLink = gql(_templateObject());

  function _templateObject$1() {
    var data = _taggedTemplateLiteral(["\n  mutation addFact($entityId: String! $factInput: addFactInput!){\n    addFact(entityId: $entityId factInput: $factInput){\n      errors\n      status\n    }\n  }\n"]);

    _templateObject$1 = function _templateObject() {
      return data;
    };

    return data;
  }
  var addFact = gql(_templateObject$1());

  function _templateObject$2() {
    var data = _taggedTemplateLiteral(["\nmutation addOffer($policyId: String! $offerInput: addOfferInput!){\n  addOffer(policyId: $policyId offerInput: $offerInput){\n    createdStatus {\n      id\n    }\n    errors\n    status\n  }\n}\n"]);

    _templateObject$2 = function _templateObject() {
      return data;
    };

    return data;
  }
  var addOffer = gql(_templateObject$2());

  function _templateObject$3() {
    var data = _taggedTemplateLiteral(["\n  query benefitCategories($productTypes: [String]){\n    benefitCategories(productTypes: $productTypes){\n      categories{\n        name\n        id\n        description\n        benefitTypeIds\n      }\n    }\n  }\n"]);

    _templateObject$3 = function _templateObject() {
      return data;
    };

    return data;
  }
  var benefitCategories = gql(_templateObject$3());

  function _templateObject$4() {
    var data = _taggedTemplateLiteral(["\n  query checkout(\n    $where: productWhereInput\n    $values:[keyValueInput]\n    $discountCodes: [String]\n    $benefitOptions: [benefitOptionInput]\n\n    $hasAdvisorId: Boolean = false\n    ) {\n    products_2(where:$where values:$values) {\n      list {\n        name\n        productId{\n          plan\n          type\n          version\n        }\n        pricing(values: $values discountCodes: $discountCodes benefitOptions: $benefitOptions){\n          formattedPrice\n          originalPrice\n          appliedDiscounts {\n            code\n            originalPrice\n            formattedOriginalPrice\n          }\n          amount\n          currencyCode\n\n          indicativePrices @include(if: $hasAdvisorId) {\n            type\n            amount\n            formattedPrice\n          }\n        }\n        benefitGraph {\n          typeId\n          value\n          #TODO: 'name' should be removed name after refactoring of sinle product layout done\n          # Single product layout component should accept prop benefitInfo so that it can compose the tree with naming\n          name\n          detailedValue\n          isOptional\n          options {\n            name\n            optionKey\n            value\n            typeId\n\n            children {\n              typeId\n              value\n              optionKey\n              name\n            }\n\n          }\n          children {\n            typeId\n            value\n            detailedValue\n            isOptional\n            options{\n              name\n              optionKey\n              value\n              typeId\n            }\n            #TODO: 'name' should be removed name after refactoring of sinle product layout done\n            # Single product layout component should accept prop benefitInfo so that it can compose the tree with naming\n            name\n            children {\n              typeId\n              value\n              detailedValue\n              isOptional\n              options{\n                name\n                optionKey\n                value\n                typeId\n              }\n              #TODO: 'name' should be removed name after refactoring of sinle product layout done\n              # Single product layout component should accept prop benefitInfo so that it can compose the tree with naming\n              name\n            }\n          }\n        }\n        checkoutConfig {\n          meta\n          fields {\n            actions {\n              on\n              payload\n              targetId\n              type\n              values\n            }\n            autocomplete\n            cssClass\n            id\n            mapTos {\n              defaultValue\n              key\n              mapTo\n            }\n            options {\n              name\n              value\n            }\n            props\n            text {\n              headline\n              subheadline\n              placeholder\n            }\n            type\n            validation\n            initialValue\n          }\n          sections {\n            fieldIds\n            id\n          }\n        }\n      }\n    }\n  }\n"]);

    _templateObject$4 = function _templateObject() {
      return data;
    };

    return data;
  }
  var checkoutConfig = gql(_templateObject$4());

  function _templateObject$5() {
    var data = _taggedTemplateLiteral(["\nmutation convertOffer($policyId: String! $offerId: String!){\n  convertOffer(policyId: $policyId offerId: $offerId){\n    errors\n    status\n  }\n}\n"]);

    _templateObject$5 = function _templateObject() {
      return data;
    };

    return data;
  }
  var convertOffer = gql(_templateObject$5()).withFieldErrorMapping();

  function _templateObject$6() {
    var data = _taggedTemplateLiteral(["\nmutation createIndividual($createIndividualInput: createIndividualInput!) {\n  createIndividual(createIndividualInput:$createIndividualInput ){\n    createdStatus{\n      id\n    }\n    errors\n    status\n  }\n}\n"]);

    _templateObject$6 = function _templateObject() {
      return data;
    };

    return data;
  }
  var createIndividual = gql(_templateObject$6()).withFieldErrorMapping();

  function _templateObject$7() {
    var data = _taggedTemplateLiteral(["\nmutation createObject($createObjectInput: createObjectInput!){\n  createObject(createObjectInput: $createObjectInput){\n    status\n    errors\n    createdStatus{\n      id\n    }\n  }\n}\n"]);

    _templateObject$7 = function _templateObject() {
      return data;
    };

    return data;
  }
  var createObject = gql(_templateObject$7());

  function _templateObject$8() {
    var data = _taggedTemplateLiteral(["\nmutation deleteEntity($id: String!) {\n  deleteEntity(id:$id ){\n    errors\n    errors_2{\n      code\n      message\n    }\n    status\n  }\n}\n"]);

    _templateObject$8 = function _templateObject() {
      return data;
    };

    return data;
  }
  var deleteEntity = gql(_templateObject$8());

  function _templateObject$9() {
    var data = _taggedTemplateLiteral(["\n  mutation initPayment($paymentInput: initializePaymentInput!) {\n    initializePayment(input: $paymentInput) {\n      errors,\n      value {\n        token\n        url\n      }\n    }\n  }\n"]);

    _templateObject$9 = function _templateObject() {
      return data;
    };

    return data;
  }
  var initializePayment = gql(_templateObject$9());

  function _templateObject$a() {
    var data = _taggedTemplateLiteral(["\nmutation initializePolicy($initializePolicyInput: initializePolicyInput){\n  initializePolicy(policy: $initializePolicyInput){\n    status\n    errors\n    policyStatus{\n      id\n    }\n  }\n}"]);

    _templateObject$a = function _templateObject() {
      return data;
    };

    return data;
  }
  var initializePolicy = gql(_templateObject$a());

  function _templateObject$b() {
    var data = _taggedTemplateLiteral(["\n  query login($tenantId: String!, $clientId: String!, $username: String!, $password: String!){\n    token_2(tenantId: $tenantId, clientId: $clientId, username: $username, password: $password) {\n      accessToken\n      expiresIn\n      error\n    }\n  }\n"]);

    _templateObject$b = function _templateObject() {
      return data;
    };

    return data;
  }
  var login = gql(_templateObject$b());

  function _templateObject$c() {
    var data = _taggedTemplateLiteral(["\nmutation processPaymentAndIssue($payment: paymentInput!){\n  processPayment_2(input: $payment){\n    status\n    errors\n  }\n}"]);

    _templateObject$c = function _templateObject() {
      return data;
    };

    return data;
  }
  var processPaymentAndIssue = gql(_templateObject$c());

  var BenefitsFragment =
  /* GraphQL */
  "\n  fragment Benefits on product {\n    benefits(typeIds: $benefitTypeIds) {\n      options {\n        benefitTypeId\n        key\n        detailedValue\n      }\n      parentTypeId\n      rawData\n      typeId\n      value\n      detailedValue\n    }\n  }\n";

  var InsurerFragment =
  /* GraphQL */
  "\n  fragment Insurer on product {\n    insurer {\n      name\n      id\n      logoUrls{\n        typeC\n      }\n    }\n  }\n";

  var PricesFragment =
  /* GraphQL */
  "\n\tfragment Prices on product {\n\t\tpricing(values: $values, discountCodes: $discountCodes) {\n\t\t\tformattedPrice\n\t\t\toriginalPrice\n\t\t\tformattedOriginalPrice\n\t\t\tamount\n\t\t\tcurrencyCode\n\n\t\t\tappliedDiscounts {\n\t\t\t\tcalculationLogic\n\t\t\t\tcode\n\t\t\t\tratio\n\t\t\t\tflat\n\t\t\t\torder\n\t\t\t\toriginalPrice\n\t\t\t\tformattedOriginalPrice\n\t\t\t\tformattedFlat\n\t\t\t}\n\n\t\t\tappliedTaxes {\n\t\t\t\tcode\n\t\t\t\tname\n\t\t\t\tratio\n\t\t\t\tflat\n\t\t\t\torder\n\t\t\t\toriginalPrice\n\t\t\t\tformattedOriginalPrice\n\t\t\t\tformattedFlat\n\t\t\t}\n\n\t\t\tindicativePrices @include(if: $hasAdvisorId) {\n\t\t\t\ttype\n\t\t\t\tamount\n\t\t\t\tcurrencyCode\n\t\t\t\tformattedOriginalPrice\n\t\t\t\tformattedPrice\n\t\t\t\toriginalPrice\n\n\t\t\t\tappliedDiscounts {\n\t\t\t\t\tcalculationLogic\n\t\t\t\t\tcode\n\t\t\t\t\tratio\n\t\t\t\t\tflat\n\t\t\t\t\torder\n\t\t\t\t\toriginalPrice\n\t\t\t\t\tformattedOriginalPrice\n\t\t\t\t\tformattedFlat\n\t\t\t\t}\n\n\t\t\t\tappliedTaxes {\n\t\t\t\t\tcode\n\t\t\t\t\tname\n\t\t\t\t\tratio\n\t\t\t\t\tflat\n\t\t\t\t\torder\n\t\t\t\t\toriginalPrice\n\t\t\t\t\tformattedOriginalPrice\n\t\t\t\t\tformattedFlat\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n";

  var ScoresFragment =
  /* GraphQL */
  "\nfragment Scores on product {\n  scores(advisorId: $advisorId values: $values) @include(if: $hasAdvisorId)  {\n    id\n    value\n    name\n  }\n}\n";

  var TagsFragment =
  /* GraphQL */
  "\n  fragment Tags on product {\n    tags {\n      id\n      name\n      type\n      description\n    }\n  }\n";

  var ProductFragment =
  /* GraphQL */
  "\n  fragment Product on product {\n    name\n    productId {\n      plan\n      type\n      version\n    }\n\n    ...Tags\n    ...Scores\n    ...Prices\n    ...Benefits\n    ...Insurer\n\n    enrollmentUrl\n  }\n  ".concat("\n    ".concat(TagsFragment, "\n    ").concat(ScoresFragment, "\n    ").concat(PricesFragment, "\n    ").concat(BenefitsFragment, "\n    ").concat(InsurerFragment, "\n    "), "\n");

  function _templateObject$d() {
    var data = _taggedTemplateLiteral(["\n\tquery listing(\n\t\t# TODO: tenantID should be removed after we factor out benefitInfos\n\t\t$tenantId: String = \"vhis_uat\"\n\t\t$where: productWhereInput\n\t\t$productTypes: [String]\n\t\t$values: [keyValueInput]\n\t\t$discountCodes: [String] = [\"\"]\n\t\t$benefitTypeIds: [String] = [\"\"]\n\t\t$productIds: productWhereInput\n\t\t$hasAdvisorId: Boolean = false\n\t\t$advisorId: String = \"\"\n\t) {\n\t\tcomparison: products_2(where: $productIds) {\n\t\t\tlist {\n\t\t\t\t...Product\n\t\t\t}\n\t\t}\n\t\tproducts: products_2(where: $where, values: $values) {\n\t\t\tlist {\n\t\t\t\t...Product\n\t\t\t}\n\t\t}\n\t\tbenefitInfos(tenantId: $tenantId, productTypes: $productTypes) {\n\t\t\tname\n\t\t\ttype\n\t\t\ttypeId\n\t\t}\n\t\tinsurers(productTypes: $productTypes) {\n\t\t\tname\n\t\t\tdetailedName\n\t\t\tid\n\t\t}\n\t}\n\t", "\n"]);

    _templateObject$d = function _templateObject() {
      return data;
    };

    return data;
  }
  /**
   * This should be used for product listing page where there is more products
   * Will fetch product with benefitGraph - only one layer
   */

  var productListing = gql(_templateObject$d(), ProductFragment);

  function _templateObject$e() {
    var data = _taggedTemplateLiteral(["\n\tquery getPrices($where: productWhereInput, $values: [keyValueInput], $discountCodes: [String], $hasAdvisorId: Boolean = false) {\n\t\tproducts: products_2(where: $where, values: $values) {\n\t\t\tlist {\n\t\t\t\tname\n\t\t\t\tproductId {\n\t\t\t\t\tplan\n\t\t\t\t\ttype\n\t\t\t\t\tversion\n\t\t\t\t}\n\t\t\t\t...Prices\n\t\t\t\tinsurer {\n\t\t\t\t\tname\n\t\t\t\t\tlogoUrls {\n\t\t\t\t\t\ttypeC\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t", "\n"]);

    _templateObject$e = function _templateObject() {
      return data;
    };

    return data;
  }
  var getPrices = gql(_templateObject$e(), PricesFragment);

  function _templateObject$f() {
    var data = _taggedTemplateLiteral(["\n\tquery single(\n\t\t$where: productWhereInput\n\t\t$productTypes: [String]\n\t\t$values: [keyValueInput]\n\t\t$discountCodes: [String]\n\t\t$hasAdvisorId: Boolean = false\n\t\t# TODO: tenantID should be removed after we factor out benefitInfos\n\t\t$tenantId: String = \"vhis_uat\"\n\t) {\n\t\tproducts: products_2(where: $where, values: $values) {\n\t\t\tlist {\n\t\t\t\tname\n\t\t\t\tproductId {\n\t\t\t\t\tplan\n\t\t\t\t\ttype\n\t\t\t\t\tversion\n\t\t\t\t}\n\t\t\t\t...Prices\n\t\t\t\tinsurer {\n\t\t\t\t\tname\n\t\t\t\t\tlogoUrls {\n\t\t\t\t\t\ttypeC\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tmajorExclusions\n\t\t\t\timportantNotes\n\t\t\t\ttermsAndConditionsUrl\n\t\t\t\tapplicationFormUrl\n\t\t\t\tenrollmentUrl\n\t\t\t\tbrochureUrl\n\t\t\t\tpremiumTableUrl\n\t\t\t\tbenefitGraph {\n\t\t\t\t\ttypeId\n\t\t\t\t\tvalue\n\t\t\t\t\t#TODO: 'name' should be removed name after refactoring of sinle product layout done\n\t\t\t\t\t# Single product layout component should accept prop benefitInfo so that it can compose the tree with naming\n\t\t\t\t\tname\n\t\t\t\t\tdetailedValue\n\t\t\t\t\tisOptional\n\t\t\t\t\toptions {\n\t\t\t\t\t\tname\n\t\t\t\t\t\toptionKey\n\t\t\t\t\t\tvalue\n\t\t\t\t\t\ttypeId\n\n\t\t\t\t\t\tchildren {\n\t\t\t\t\t\t\ttypeId\n\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t\toptionKey\n\t\t\t\t\t\t\tname\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tchildren {\n\t\t\t\t\t\ttypeId\n\t\t\t\t\t\tvalue\n\t\t\t\t\t\tdetailedValue\n\t\t\t\t\t\tisOptional\n\t\t\t\t\t\toptions {\n\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\toptionKey\n\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t\ttypeId\n\t\t\t\t\t\t}\n\t\t\t\t\t\t#TODO: 'name' should be removed name after refactoring of sinle product layout done\n\t\t\t\t\t\t# Single product layout component should accept prop benefitInfo so that it can compose the tree with naming\n\t\t\t\t\t\tname\n\t\t\t\t\t\tchildren {\n\t\t\t\t\t\t\ttypeId\n\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t\tdetailedValue\n\t\t\t\t\t\t\tisOptional\n\t\t\t\t\t\t\toptions {\n\t\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\t\toptionKey\n\t\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t\t\ttypeId\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t#TODO: 'name' should be removed name after refactoring of sinle product layout done\n\t\t\t\t\t\t\t# Single product layout component should accept prop benefitInfo so that it can compose the tree with naming\n\t\t\t\t\t\t\tname\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tbenefitInfos(tenantId: $tenantId, productTypes: $productTypes) {\n\t\t\tname\n\t\t\tdescription\n\t\t\ttype\n\t\t\ttypeId\n\t\t}\n\t\tbenefitCategories(productTypes: $productTypes) {\n\t\t\tcategories {\n\t\t\t\tname\n\t\t\t\tid\n\t\t\t\tdescription\n\t\t\t\tbenefitTypeIds\n\t\t\t}\n\t\t\tproductType\n\t\t}\n\t}\n\t", "\n"]);

    _templateObject$f = function _templateObject() {
      return data;
    };

    return data;
  }
  /**
   * This should be used for product listing for single layout as well as for product detail
   * Will fetch products using benefitGraph field + will fetch benefitInfos
   * From this query client can compose benefitTree with naming coming from benefitInfos
   * BenefitGraph goes 3 layers down only
   */

  var singleProduct = gql(_templateObject$f(), PricesFragment);

  function _templateObject$g() {
    var data = _taggedTemplateLiteral(["\nmutation upsertBenefitOption($policyId: String! $input: benefitOptionInput!){\n  upsertBenefitOption(policyId: $policyId input:$input){\n    errors\n    status\n  }\n}\n"]);

    _templateObject$g = function _templateObject() {
      return data;
    };

    return data;
  }
  var upsertBenefitOption = gql(_templateObject$g());

  function _templateObject$h() {
    var data = _taggedTemplateLiteral(["\n  query validatePolicy ($policyId: String!) {\n    validatePolicy_2(policyId: $policyId) {\n      status\n      errors\n      errors_2 {\n        code\n        message\n      }\n    }\n  }\n"]);

    _templateObject$h = function _templateObject() {
      return data;
    };

    return data;
  }
  var validatePolicy = gql(_templateObject$h()).withFieldErrorMapping();

  function _templateObject$i() {
    var data = _taggedTemplateLiteral(["\n\tmutation initializeTransaction($input: initializeTransactionInput!) {\n\t\tinitializeTransaction(input: $input) {\n\t\t\terrors\n\t\t\tvalue {\n\t\t\t\thttpMethod\n\t\t\t\ttoken\n\t\t\t\ttransactionId\n\t\t\t\turl\n\t\t\t\tparameters {\n\t\t\t\t\tobjectValue {\n\t\t\t\t\t\tkey\n\t\t\t\t\t\tvalue {\n\t\t\t\t\t\t\tstringValue\n\t\t\t\t\t\t\tnumberValue\n\t\t\t\t\t\t\tbooleanValue\n\t\t\t\t\t\t\tdateValue\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"]);

    _templateObject$i = function _templateObject() {
      return data;
    };

    return data;
  }
  var initializeTransaction = gql(_templateObject$i()).withFieldErrorMapping();

  function _templateObject$j() {
    var data = _taggedTemplateLiteral(["\n\tmutation processTransaction($transactionId: String!, $input: processTransactionInput!, $tryIssue: Boolean) {\n\t\tprocessTransaction(transactionId: $transactionId, input: $input, tryIssue: $tryIssue) {\n\t\t\terrors\n\t\t\tstatus\n\t\t\tpolicyStatus {\n\t\t\t\tid\n\t\t\t\tstatus\n\t\t\t}\n\t\t}\n\t}\n"]);

    _templateObject$j = function _templateObject() {
      return data;
    };

    return data;
  }
  var processTransaction = gql(_templateObject$j()).withFieldErrorMapping();

  var recursiveValues = function recursiveValues() {
    var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
    var scalarValues = "\n    booleanValue\n\t\tdateValue\n\t\tstringValue\n\t\tnumberValue";

    var recursion = function recursion(layers) {
      var run = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (run > layers) return scalarValues;
      run++;
      var output = scalarValues;
      output += " arrayValue{";
      output += recursion(layers, run);
      output += "}";
      output += " objectValue{ key value{";
      output += recursion(layers, run);
      output += "}}";
      return output;
    };

    return recursion(layers);
  };

  function _templateObject$k() {
    var data = _taggedTemplateLiteral(["\n\tquery initializeCheckout(\n\t\t$where: productWhereInput\n\t\t$values: [keyValueInput]\n\t\t$discountCodes: [String]\n\t\t$hasAdvisorId: Boolean = false\n\t\t$typeIds: [String]\n\t) {\n\t\tproducts: products_2(where: $where, values: $values) {\n\t\t\tlist {\n\t\t\t\tname\n\t\t\t\tproductId {\n\t\t\t\t\tplan\n\t\t\t\t\ttype\n\t\t\t\t\tversion\n\t\t\t\t}\n\t\t\t\tbenefits(typeIds: $typeIds) {\n\t\t\t\t\tname\n\t\t\t\t\ttypeId\n\t\t\t\t\toptionKey\n\t\t\t\t\tformattedValue: value\n\t\t\t\t\tvalue: value2 {\n\t\t\t\t\t\t", "\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t...Prices\n\t\t\t\tinsurer {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t\tdetailedName\n\t\t\t\t\tlogoUrls {\n\t\t\t\t\t\ttypeA\n\t\t\t\t\t\ttypeB\n\t\t\t\t\t\ttypeC\n\t\t\t\t\t\ttypeD\n\t\t\t\t\t\ttypeE\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t", "\n"]);

    _templateObject$k = function _templateObject() {
      return data;
    };

    return data;
  }
  var initializeCheckout = gql(_templateObject$k(), recursiveValues(), PricesFragment);

  var batchAddLinks =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(_ref) {
      var createdEntities, token, locale, _ref$options, options, _ref$__debug, __debug, addLinksResults;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              createdEntities = _ref.createdEntities, token = _ref.token, locale = _ref.locale, _ref$options = _ref.options, options = _ref$options === void 0 ? {
                url: "https://api.covergo.com/graphql"
              } : _ref$options, _ref$__debug = _ref.__debug, __debug = _ref$__debug === void 0 ? false : _ref$__debug;
              _context.next = 3;
              return Promise.all(createdEntities.reduce(function (acc, _ref3) {
                var systemId = _ref3.systemId,
                    _ref3$links = _ref3.links,
                    links = _ref3$links === void 0 ? [] : _ref3$links;
                if (!links.length) return acc;
                return [].concat(_toConsumableArray(acc), _toConsumableArray(links.map(function (currentLink) {
                  return addLink({
                    variables: {
                      linkInput: {
                        sourceId: systemId,
                        link: currentLink.link,
                        targetId: createdEntities.find(function (e) {
                          return e.tempId === currentLink.tempTargetId;
                        }).systemId
                      }
                    },
                    token: token,
                    locale: locale,
                    options: options,
                    __debug: __debug
                  });
                })));
              }, []));

            case 3:
              addLinksResults = _context.sent;
              if (__debug) console.log('addLinksResults', JSON.stringify(addLinksResults)); // If errors

              if (!addLinksResults.find(function (batch) {
                return batch.errors;
              })) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", Promise.resolve({
                errors: _toConsumableArray(addLinksResults.filter(function (batch) {
                  return batch.errors;
                }))
              }));

            case 7:
              return _context.abrupt("return", Promise.resolve(addLinksResults));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function batchAddLinks(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var inputTypeMappingForType = {
    individual: 'createIndividualInput',
    object: 'createObjectInput',
    company: 'createCompanyInput'
  };
  var functionMappingForType = {
    individual: createIndividual,
    object: createObject
  };
  var dataKeyMappingForType = {
    individual: 'createIndividual',
    object: 'createObject',
    company: 'createCompany'
  };

  var createEntityByType =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(entity, token, locale, options, __debug) {
      var apiParams, entityType, tempId, isHolder, isOtherHolder, isInsured, links, baseEntity, res, systemId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              apiParams = {
                token: token,
                locale: locale,
                options: options,
                __debug: __debug
              };
              entityType = entity.entityType, tempId = entity.tempId, isHolder = entity.isHolder, isOtherHolder = entity.isOtherHolder, isInsured = entity.isInsured, links = entity.links, baseEntity = _objectWithoutProperties(entity, ["entityType", "tempId", "isHolder", "isOtherHolder", "isInsured", "links"]);
              apiParams.variables = _defineProperty({}, inputTypeMappingForType[entityType], baseEntity);
              _context.next = 5;
              return functionMappingForType[entityType](_objectSpread({}, apiParams));

            case 5:
              res = _context.sent;

              if (!(res.errors && res.errors.length)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", _objectSpread({
                errors: res.errors
              }, baseEntity));

            case 8:
              _context.next = 10;
              return res.data[dataKeyMappingForType[entityType]].createdStatus.id;

            case 10:
              systemId = _context.sent;
              return _context.abrupt("return", _objectSpread({
                systemId: systemId
              }, entity));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createEntityByType(_x, _x2, _x3, _x4, _x5) {
      return _ref.apply(this, arguments);
    };
  }();

  var batchCreateAllEntities =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(_ref2) {
      var payload, token, locale, _ref2$options, options, _ref2$__debug, __debug, createdEntities;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              payload = _ref2.payload, token = _ref2.token, locale = _ref2.locale, _ref2$options = _ref2.options, options = _ref2$options === void 0 ? {
                url: "https://api.covergo.com/graphql"
              } : _ref2$options, _ref2$__debug = _ref2.__debug, __debug = _ref2$__debug === void 0 ? false : _ref2$__debug;
              _context2.next = 3;
              return Promise.all(payload.entities.map(function (entity) {
                return createEntityByType(entity, token, locale, options, __debug);
              }));

            case 3:
              createdEntities = _context2.sent;

              if (!createdEntities.find(function (entity) {
                return entity.errors && entity.errors.length;
              })) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return", Promise.resolve({
                errors: _toConsumableArray(createdEntities.reduce(function (acc, cur) {
                  return [].concat(_toConsumableArray(acc), _toConsumableArray(cur.errors));
                }, []))
              }));

            case 6:
              return _context2.abrupt("return", Promise.resolve(createdEntities));

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function batchCreateAllEntities(_x6) {
      return _ref3.apply(this, arguments);
    };
  }();

  var batchInitializePolicy =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(_ref) {
      var payload, createdEntities, token, locale, _ref$options, options, _ref$__debug, __debug, _payload$policyPartic, startDate, endDate, productId, referralCode, source, values, facts, insuredIds, holderId, otherHolderIds, initializePolicyInput, res, policyId;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              payload = _ref.payload, createdEntities = _ref.createdEntities, token = _ref.token, locale = _ref.locale, _ref$options = _ref.options, options = _ref$options === void 0 ? {
                url: "https://api.covergo.com/graphql"
              } : _ref$options, _ref$__debug = _ref.__debug, __debug = _ref$__debug === void 0 ? false : _ref$__debug;
              // We are also passing these
              _payload$policyPartic = payload.policyParticulars, startDate = _payload$policyPartic.startDate, endDate = _payload$policyPartic.endDate, productId = _payload$policyPartic.productId, referralCode = _payload$policyPartic.referralCode, source = _payload$policyPartic.source, values = _payload$policyPartic.values, facts = _payload$policyPartic.facts;
              insuredIds = createdEntities.filter(function (_ref3) {
                var isInsured = _ref3.isInsured;
                return isInsured;
              }).map(function (entity) {
                return entity.systemId;
              });
              holderId = createdEntities.filter(function (_ref4) {
                var isHolder = _ref4.isHolder;
                return isHolder;
              }).map(function (entity) {
                return entity.systemId;
              })[0];
              otherHolderIds = createdEntities.filter(function (_ref5) {
                var isOtherHolder = _ref5.isOtherHolder;
                return isOtherHolder;
              }).map(function (entity) {
                return entity.systemId;
              });
              initializePolicyInput = {
                holderId: holderId,
                insuredIds: insuredIds,
                startDate: startDate,
                endDate: endDate,
                productId: productId,
                referralCode: referralCode,
                source: source,
                values: values,
                facts: facts,
                otherHolderIds: otherHolderIds // Initialize policy

              };
              _context.next = 8;
              return initializePolicy({
                variables: {
                  initializePolicyInput: initializePolicyInput
                },
                token: token,
                locale: locale,
                options: options,
                __debug: __debug
              });

            case 8:
              res = _context.sent;

              if (!res.errors) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", Promise.resolve({
                errors: res.errors
              }));

            case 11:
              policyId = res.data.initializePolicy.policyStatus.id;
              return _context.abrupt("return", Promise.resolve(policyId));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function batchInitializePolicy(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var createPolicy =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(_ref) {
      var variables, token, locale, needsOfflineUnderwriting, _ref$options, options, _ref$__debug, __debug, payloadForQuote, createdEntities, policyId, createdLinks, _variables$policyPart, productId, pricing, benefitOptions, offerInput, createdOffer, offerId, convertedOffer;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              variables = _ref.variables, token = _ref.token, locale = _ref.locale, needsOfflineUnderwriting = _ref.needsOfflineUnderwriting, _ref$options = _ref.options, options = _ref$options === void 0 ? {
                url: "https://api.covergo.com/graphql"
              } : _ref$options, _ref$__debug = _ref.__debug, __debug = _ref$__debug === void 0 ? false : _ref$__debug;
              payloadForQuote = JSON.parse(JSON.stringify(variables));

              if (payloadForQuote.policyParticulars.pricing !== undefined && payloadForQuote.policyParticulars.productId !== undefined) {
                delete payloadForQuote.policyParticulars.pricing;
                delete payloadForQuote.policyParticulars.productId;
              } // ------------------------------------------------------------
              // 1 Create all entities
              // ------------------------------------------------------------


              _context.next = 5;
              return batchCreateAllEntities({
                payload: payloadForQuote,
                token: token,
                locale: locale,
                options: options,
                __debug: __debug
              });

            case 5:
              createdEntities = _context.sent;

              if (!createdEntities.errors) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", Promise.resolve({
                errors: createdEntities.errors
              }));

            case 8:
              _context.next = 10;
              return batchInitializePolicy({
                payload: payloadForQuote,
                createdEntities: createdEntities,
                token: token,
                locale: locale,
                options: options,
                __debug: __debug
              });

            case 10:
              policyId = _context.sent;

              if (!policyId.errors) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("return", Promise.resolve({
                errors: policyId.errors
              }));

            case 13:
              _context.next = 15;
              return batchAddLinks({
                payload: payloadForQuote,
                policyId: policyId,
                createdEntities: createdEntities,
                token: token,
                locale: locale,
                options: options,
                __debug: __debug
              });

            case 15:
              createdLinks = _context.sent;

              if (!createdLinks.errors) {
                _context.next = 18;
                break;
              }

              return _context.abrupt("return", Promise.resolve({
                errors: createdLinks.errors
              }));

            case 18:
              // ------------------------------------------------------------
              // 4 Add offer to that policy return policy Id if needsOfflineUnderwriting === true
              // ------------------------------------------------------------
              _variables$policyPart = variables.policyParticulars, productId = _variables$policyPart.productId, pricing = _variables$policyPart.pricing, benefitOptions = _variables$policyPart.benefitOptions;
              offerInput = {
                productId: productId,
                benefitOptions: benefitOptions,
                premium: pricing // ...pricing?.discountCodes && {premium: { discountCodes: pricing.discountCodes }} // pricing should be added to maptos from crm to allow overrides, but not from coverquote

              };
              _context.next = 22;
              return addOffer({
                variables: {
                  policyId: policyId,
                  offerInput: offerInput
                },
                token: token,
                options: options,
                locale: locale,
                __debug: __debug
              });

            case 22:
              createdOffer = _context.sent;

              if (!createdOffer.errors) {
                _context.next = 25;
                break;
              }

              return _context.abrupt("return", Promise.resolve({
                errors: createdOffer.errors
              }));

            case 25:
              offerId = createdOffer.data.addOffer.createdStatus.id;

              if (!needsOfflineUnderwriting) {
                _context.next = 28;
                break;
              }

              return _context.abrupt("return", Promise.resolve({
                policyId: policyId
              }));

            case 28:
              _context.next = 30;
              return convertOffer({
                variables: {
                  policyId: policyId,
                  offerId: offerId
                },
                token: token,
                locale: locale,
                options: options,
                __debug: __debug
              });

            case 30:
              convertedOffer = _context.sent;

              if (!convertedOffer.errors) {
                _context.next = 33;
                break;
              }

              return _context.abrupt("return", Promise.resolve({
                errors: convertedOffer.errors
              }));

            case 33:
              return _context.abrupt("return", Promise.resolve({
                policyId: policyId
              }));

            case 34:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createPolicy(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var createQuote =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(_ref) {
      var payload, token, locale, _ref$options, options, _ref$__debug, __debug, policyId;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              payload = _ref.payload, token = _ref.token, locale = _ref.locale, _ref$options = _ref.options, options = _ref$options === void 0 ? {
                url: "https://api.covergo.com/graphql"
              } : _ref$options, _ref$__debug = _ref.__debug, __debug = _ref$__debug === void 0 ? false : _ref$__debug;
              _context.next = 3;
              return createPolicy({
                payload: payload,
                token: token,
                locale: locale,
                needsOfflineUnderwriting: true,
                options: options,
                __debug: __debug
              });

            case 3:
              policyId = _context.sent;

              if (!policyId.errors) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", Promise.resolve({
                errors: policyId.errors
              }));

            case 6:
              return _context.abrupt("return", Promise.resolve(true));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createQuote(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var payAndIssuePolicy =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(_ref) {
      var payload, paymentToken, policyId, token, locale, _ref$options, options, _ref$__debug, __debug, issuedPolicy;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              payload = _ref.payload, paymentToken = _ref.paymentToken, policyId = _ref.policyId, token = _ref.token, locale = _ref.locale, _ref$options = _ref.options, options = _ref$options === void 0 ? {
                url: "https://api.covergo.com/graphql"
              } : _ref$options, _ref$__debug = _ref.__debug, __debug = _ref$__debug === void 0 ? false : _ref$__debug;
              _context.next = 3;
              return processPaymentAndIssue({
                paymentInput: {
                  policyId: policyId,
                  amount: payload.policyParticulars.pricing.amount,
                  currencyCode: payload.policyParticulars.pricing.currencyCode,
                  userToken: paymentToken
                },
                token: token,
                locale: locale,
                options: options,
                __debug: __debug
              });

            case 3:
              issuedPolicy = _context.sent;

              if (!issuedPolicy.errors) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", Promise.resolve({
                errors: issuedPolicy.errors
              }));

            case 6:
              return _context.abrupt("return", Promise.resolve(true));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function payAndIssuePolicy(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var gqlES5 =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(_ref) {
      var _ref$query, query, _ref$variables, variables, _ref$url, _ref$method, method, _ref$locale, locale, _ref$token, token, _ref$headers, _ref$options, options, _ref$__debug, __debug, json, opts, res, resData;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref$query = _ref.query, query = _ref$query === void 0 ? null : _ref$query, _ref$variables = _ref.variables, variables = _ref$variables === void 0 ? null : _ref$variables, _ref$url = _ref.url, _ref$method = _ref.method, method = _ref$method === void 0 ? "POST" : _ref$method, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$token = _ref.token, token = _ref$token === void 0 ? null : _ref$token, _ref$headers = _ref.headers, _ref$options = _ref.options, options = _ref$options === void 0 ? {
                url: "https://api.covergo.com/graphql"
              } : _ref$options, _ref$__debug = _ref.__debug, __debug = _ref$__debug === void 0 ? false : _ref$__debug;
              if (!query) console.error("GQL: there was no query to send");

              if (__debug) {
                console.group("--------------- API REQUEST ---------------");
                console.log("Language: ".concat(locale));
                console.log("Query: \n", query);
                console.log("Variables:", variables);
                console.groupEnd();
              }

              json = JSON.stringify({
                query: query,
                variables: variables
              });
              opts = {
                method: method,
                headers: _objectSpread({
                  "Content-Type": "application/json",
                  "Accept-Language": locale,
                  Authorization: "Bearer ".concat(token)
                }, options.headers && options.headers),
                body: json
              };
              _context.next = 7;
              return crossFetch.fetch(options.url, opts);

            case 7:
              res = _context.sent;
              if (__debug) console.log(res);

              if (!(res.status >= 400)) {
                _context.next = 11;
                break;
              }

              throw new Error("Network error from GQL");

            case 11:
              _context.next = 13;
              return res.json();

            case 13:
              resData = _context.sent;
              return _context.abrupt("return", Promise.resolve(resData));

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function gqlES5(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  exports.addFact = addFact;
  exports.addLink = addLink;
  exports.addOffer = addOffer;
  exports.batchAddLinks = batchAddLinks;
  exports.batchCreateAllEntities = batchCreateAllEntities;
  exports.batchInitializePolicy = batchInitializePolicy;
  exports.benefitCategories = benefitCategories;
  exports.checkoutConfig = checkoutConfig;
  exports.convertOffer = convertOffer;
  exports.createIndividual = createIndividual;
  exports.createObject = createObject;
  exports.createPolicy = createPolicy;
  exports.createQuote = createQuote;
  exports.deleteEntity = deleteEntity;
  exports.getPrices = getPrices;
  exports.gql = gql;
  exports.gqlES5 = gqlES5;
  exports.initializeCheckout = initializeCheckout;
  exports.initializePayment = initializePayment;
  exports.initializePolicy = initializePolicy;
  exports.initializeTransaction = initializeTransaction;
  exports.login = login;
  exports.payAndIssuePolicy = payAndIssuePolicy;
  exports.processPaymentAndIssue = processPaymentAndIssue;
  exports.processTransaction = processTransaction;
  exports.productListing = productListing;
  exports.singleProduct = singleProduct;
  exports.upsertBenefitOption = upsertBenefitOption;
  exports.validatePolicy = validatePolicy;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
